import { Button, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { Position } from "../api";
import { CsvColumn, useDownloadCsv } from "../util";

interface DownloadOperationRunProps {
  runId: string;
  positions: Position[];
  from: Date;
  to: Date | null;
  loading: boolean;
  disabled: boolean;
  style?: React.CSSProperties;
}

export function DownloadOperationRun({
  positions,
  from,
  to,
  runId,
  loading,
  disabled,
  style,
}: DownloadOperationRunProps) {
  const { t } = useTranslation();

  const download = useDownloadCsv(
    runId,
    positions,
    columns,
    `OperationRunPositions_${runId}_${from}_${to}.csv`
  );

  return (
    <div data-testid="download-operation-run" style={style}>
      <Button
        type={disabled ? "dashed" : "primary"}
        onClick={download}
        disabled={disabled}
      >
        <Spin spinning={loading} size="small" className="centered" />
        {t("save-as-csv")}
      </Button>
    </div>
  );
}

const columns: CsvColumn<Position>[] = [
  {
    title: "Timestamp",
    value: (p, c) => p.ts.toLocaleString(c),
  },
  {
    title: "Latitude",
    value: (p, c) => p.lat.toFixed(9),
  },
  {
    title: "Longitude",
    value: (p, c) => p.lon.toFixed(9),
  },
  {
    title: "Altitude",
    value: (p, c) => p.alt.toFixed(1),
  },
  {
    title: "Horizontal Accuracy",
    value: (p, c) => p.acc.h.toFixed(1),
  },
  {
    title: "Satellites Used",
    value: (p, c) => p.sats,
  },
  {
    title: "CPRS",
    value: (p, c) => p.cprs,
  },
];
